import { z } from 'zod';
/**
 * Employee directory (MGOS fase 5, W5-4) — shared contracts.
 *
 * The verkenning §1 lists "Contacten" as **absent as a directory**: the CRM's
 * "Kontakte" is the `leads` table, and `User` had no display name at all —
 * which is why `verwaltung.service.ts` had to invent one from the e-mail
 * address for the ONYX handoff. This is the smallest thing that makes "who
 * works here" answerable, and the precondition for search (W5-14) and for any
 * later mention/assignment surface.
 *
 * WHAT IT DELIBERATELY IS NOT: a contact database. No phone, no address, no
 * private data, no free-text profile. Name, role, e-mail — the three fields a
 * colleague needs to reach you at work and nothing that would turn an internal
 * list into a personal-data store with its own retention question.
 */
/** Bounded so a name cannot become a free-text profile field by stealth. */
export const displayNameSchema = z.string().trim().min(1).max(120);
/** GET /directory. One optional substring filter; the server does the matching. */
export const directoryQuerySchema = z.object({
    /** Case-insensitive substring over name AND e-mail. */
    q: z.string().trim().max(120).optional(),
});
